/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Correct_SaveInputs */

const en_us2_workout_correct_save = /** @type {(inputs: Workout_Correct_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save correction`)
};

const pt_br2_workout_correct_save = /** @type {(inputs: Workout_Correct_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar correção`)
};

const es_419_workout_correct_save = /** @type {(inputs: Workout_Correct_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar corrección`)
};

const pt_pt2_workout_correct_save = /** @type {(inputs: Workout_Correct_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar correção`)
};

const fr_fr2_workout_correct_save = /** @type {(inputs: Workout_Correct_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer la correction`)
};

const de_de2_workout_correct_save = /** @type {(inputs: Workout_Correct_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korrektur speichern`)
};

const it_it2_workout_correct_save = /** @type {(inputs: Workout_Correct_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva correzione`)
};

/**
* | output |
* | --- |
* | "Save correction" |
*
* @param {Workout_Correct_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_correct_save = /** @type {((inputs?: Workout_Correct_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Correct_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_correct_save(inputs)
	if (locale === "es-419") return es_419_workout_correct_save(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_correct_save(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_correct_save(inputs)
	if (locale === "de-DE") return de_de2_workout_correct_save(inputs)
	if (locale === "it-IT") return it_it2_workout_correct_save(inputs)
	return en_us2_workout_correct_save(inputs)
});
export { workout_correct_save as "workout.correct_save" }